<template>
	<div>
		<PageHeaderLayout>
			<div class="main-page-content">
				<el-row class="table-search">
					<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
						<el-form-item v-for="item in searchList" :key="item.props" :label="item.label">
							<el-input
								v-if="item.type === 'input'"
								v-model="searchCondition[item.props]"
								:placeholder="'请输入' + item.label"
								clearable
							></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton">查询</el-button>
							<el-button type="primary" @click="batchAudit">批量审核</el-button>
						</el-form-item>
					</el-form>
				</el-row>
				<ApeTable
					ref="apeTable"
					:data="tableData"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					@switchPaging="switchPaging"
					@selectList="handleSelectList"
					highlight-current-row
				>
					<el-table-column slot="first-column" type="selection" width="55" align="center" :selectable="selectable"></el-table-column>
					<el-table-column label="操作" width="140" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button type="text" size="mini" @click="goCompanyDetail(scope.row)">查看</el-button>
							<el-button v-if="scope.row.examine_status == 0" type="text" size="mini" @click="openAudit(scope.row)">审核</el-button>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>

		<el-dialog title="保险审核" :visible.sync="auditVisible" width="35%" @close="auditCancel">
			<div class="audit-text">是否同意{{ auditCompanyName }}开通蚂蚁保页面？</div>
			<span slot="footer" class="dialog-footer">
				<el-button :loading="auditLoading" @click="submitAudit(2)">拒 绝</el-button>
				<el-button type="primary" :loading="auditLoading" @click="submitAudit(1)">通 过</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import { search_list, tableColumns } from './config/insuranceReview.ts'

export default {
	name: 'InsuranceReview',
	components: {
		PageHeaderLayout,
		ApeTable
	},
	data() {
		return {
			searchCondition: {},
			searchList: search_list,
			loadingStaus: true,
			auditVisible: false,
			auditLoading: false,
			auditCompanyName: '',
			selectedRows: [],
			taxpayers: [],
			tableData: [],
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			examineStatusMap: {
				0: '待审核',
				1: '审核通过',
				2: '审核拒绝'
			},
			columns: tableColumns
		}
	},
	methods: {
		selectable(row) {
			return row.examine_status == 0
		},
		handleSelectList(list) {
			this.selectedRows = list
		},
		searchButton() {
			this.initList('search')
		},
		switchPaging() {
			this.initList()
		},
		goCompanyDetail(row) {
			this.$router.push({
				path: '/manager/insuranceDetail',
				query: {
					taxpayer: row.taxpayer,
					product_plan_id: row.product_product_plan_id,
					job_level: row.job_level
				}
			})
		},
		openAudit(row) {
			this.taxpayers = [row.taxpayer]
			this.auditCompanyName = row.company_name
			this.auditVisible = true
		},
		batchAudit() {
			if (!this.selectedRows.length) {
				this.$message.error('至少选择一项')
				return
			}
			this.taxpayers = this.selectedRows.map(item => item.taxpayer)
			this.auditCompanyName = this.selectedRows.map(item => item.company_name).join('、')
			this.auditVisible = true
		},
		auditCancel() {
			this.auditVisible = false
			this.taxpayers = []
			this.auditCompanyName = ''
		},
		async submitAudit(status) {
			if (!this.$api.examineMerchant) {
				this.$message.error('请先提供保险审核接口')
				return
			}
			this.auditLoading = true
			try {
				await this.$api.examineMerchant({
					taxpayers: this.taxpayers,
					status
				})
				this.$message.success('审核成功')
				this.auditCancel()
				this.initList()
				this.selectedRows = []
			} catch (e) {
				this.$message.error(e.message || '审核失败')
			}
			this.auditLoading = false
		},
		formatList(list) {
			return list.map(item => {
				const rawStatus = item.examine_status != null && item.examine_status !== '' ? item.examine_status : item.status
				return {
					...item,
					examine_status: rawStatus != null && rawStatus !== '' ? String(rawStatus) : '0',
					examine_status_text: this.examineStatusMap[rawStatus] || this.examineStatusMap[String(rawStatus)] || '-'
				}
			})
		},
		async initList(type) {
			this.loadingStaus = true
			const pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
			if (type === 'search') {
				pagingInfo.current_page = 1
			}
			try {
				const params = {
					...this.searchCondition,
					...pagingInfo,
					page: pagingInfo.current_page
				}
				delete params.current_page
				const res = await this.$api.getBusinessList(params)
				const list = res.items || res.data || res.list || []
				this.tableData = this.formatList(list)
				this.pagingData.total = res.total || (res.pages && res.pages.total) || 0
				this.pagingData.offset = res.offset || (res.pages && res.pages.offset) || 0
			} catch (e) {
				this.tableData = []
				this.$message.error(e.message || '获取保险审核列表失败')
			}
			this.loadingStaus = false
		}
	},
	mounted() {
		this.initList()
	}
}
</script>

<style lang="scss" scoped>
.table-search {
	margin-bottom: 16px;
}
.audit-text {
	font-size: 15px;
	line-height: 25px;
}
</style>
